import React from 'react';
import './ProductView.scss';
import { ProductViewModes } from '@/utils/productStateUtils';
import ProductChangeRequest from '@/components/partials/ProductView/ProductChangeRequest/ProductChangeRequest';
import ProductReadOnly from '@/components/partials/ProductView/ProductReadOnly/ProductReadOnly';
import ProductEdit from '@/components/partials/ProductView/ProductEdit/ProductEdit';
import ProductChangeRequestRO from '@/components/partials/ProductView/ProductChangeRequestRO/ProductChangeRequestRO';

interface ProductViewProps {
  productViewMode?: ProductViewModes;
}

export default function ProductView({
  productViewMode = ProductViewModes.ReadOnly,
}: ProductViewProps) {
  switch (productViewMode) {
    case ProductViewModes.Edit:
      return <ProductEdit />;
    case ProductViewModes.ChangeRequest:
      return <ProductChangeRequest />;
    case ProductViewModes.ChangeRequestReadOnly:
      return <ProductChangeRequestRO />;
    case ProductViewModes.ReadOnly:
    default:
      return <ProductReadOnly />;
  }
}
